import { isPlaceholderPartecipant } from "./func.utils"
import { isSubscriptionCourse, isSubstitute } from "./substitutes.utils"

// ──────────────────────────────────────────────────────────────────────────
// LEZIONI ANNULLATE
//
// Una privata che salta si elimina e basta. Un corso in abbonamento no: gli
// abbonati l'hanno già pagata, e la lezione persa va recuperata. La lezione
// annullata resta salvata con `cancelled: true` e tutti gli abbonati
// assenti: il conteggio dei recuperi che c'è già la conta così com'è, senza
// sapere niente di annullamenti.
//
// Una lezione che non si è fatta non conta in ore, compensi, quota da
// fatturare al circolo e uso dei campi.
// ──────────────────────────────────────────────────────────────────────────

export const isCancelledLesson = lesson => lesson?.cancelled === true

// Solo i corsi in abbonamento hanno qualcosa da recuperare: le altre lezioni
// si eliminano come sempre.
export const canCancelLesson = lesson =>
	!isCancelledLesson(lesson) && isSubscriptionCourse(lesson?.lessonType)

// Le lezioni che si sono fatte, o si faranno: quelle che contano.
export const heldLessons = lessons => (lessons ?? []).filter(lesson => !isCancelledLesson(lesson))

// Chi è nella lezione annullata. Gli abbonati restano assenti, ed è
// quell'assenza il recupero. Chi pagava la volta (e chi recuperava, e i
// sostituti) resta in lezione ma senza pagamento: la lezione non si è fatta,
// non c'è niente da pagare né da recuperare — e chi recuperava il suo
// recupero se lo ritrova. I posti senza nome restano com'erano: non sono
// nessuno, e un'assenza non la possono avere.
export const cancelledPartecipants = partecipants =>
	(partecipants ?? []).map(player => {
		if (isPlaceholderPartecipant(player)) return player
		if (!isSubstitute(player) && player.paymentMethod === "subscription")
			return { ...player, isPresent: false }
		const { paidTo, ...rest } = player
		return { ...rest, isPresent: false, paymentMethod: "", paymentAmount: 0 }
	})

// Chi va nella lezione di recupero di una lezione annullata: gli abbonati, e
// solo loro, tutti presenti e col recupero. Le presenze sono quelle di
// prima dell'annullamento, se ci sono: lì si vede chi aveva l'abbonamento.
export const recoveryPartecipants = lesson =>
	(lesson?.partecipantsBeforeCancel ?? lesson?.partecipants ?? [])
		.filter(
			player =>
				!isSubstitute(player) &&
				!isPlaceholderPartecipant(player) &&
				player.paymentMethod === "subscription",
		)
		.map(({ paidTo, substituteFor, ...player }) => ({
			...player,
			isPresent: true,
			paymentMethod: "recovery",
			paymentAmount: 0,
			paymentAmountIsCustom: false,
		}))
